<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Manage Activity </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        item-value="ay_id"
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="activity_category"
                        item-value="id"
                        :items="activity_category_list_with_all"
                        item-text="name"
                        label="Select Category"
                        outlined
                        persistent-hint
                        hint="Please select category"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="mt-6 button" v-if="sel_ay_data" @click="onload()">Fetch</v-btn>
                    <v-btn class="mt-6 button" @click="dialog_new=true">Add New Activity</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display" v-if="activity_data_list!=''">
                <v-col cols="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>Activity Details</strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <br />
                    <v-data-table
                        :headers="activity_headers"
                        :items="activity_data_list"
                        class="elevation-1 mytable"
                        dense
                        item-key="id"
                    >
                        <template v-slot:item.coordinator="{ item }"> {{ item.coordinator || '-' }} </template>

                        <template v-slot:item.venue="{ item }"> {{ item.venue || '-' }} </template>

                        <template v-slot:item.description="{ item }"> {{ item.description || '-' }} </template>

                        <template v-slot:item.is_attendance_required="{ item }">
                            <span v-if="item.is_attendance_required">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>

                        <template v-slot:item.is_certificate_enabled="{ item }">
                            <span v-if="item.is_certificate_enabled">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>

                        <template v-slot:item.is_feedback_enabled="{ item }">
                            <span v-if="item.is_feedback_enabled">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>

                        <template v-slot:item.is_fees_applicable="{ item }">
                            <span v-if="item.is_fees_applicable">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.is_multiple_sessions_allowed="{ item }">
                            <span v-if="item.is_multiple_sessions_allowed">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>

                        <template v-slot:item.is_approval_required="{ item }">
                            <span v-if="item.is_approval_required">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.isactive="{ item }">
                            <span v-if="item.isactive">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.venue="{ item }">
                            <v-btn icon small @click="openVenueDialog(item)">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.feedback_summary="{ item }">
                            <v-btn icon small @click="openFeedbackSummary(item)">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:item.certificate="{ item }">
                            <v-btn icon small @click="openCertificateListDialog(item)">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        
                    <template v-slot:item.activity_url="{ item }">
                        <v-btn icon small @click="openActivityUrlDialog(item)">
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </template>


                        <!-- Description -->
                        <template v-slot:item.description="{ item }">
                            <v-btn icon small @click="openDescriptionDialog(item)">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.fee_structure="{ item }">
                            <span v-if="item.is_fees_applicable">
                                <v-btn icon small @click="openFeeStructureDialog(item)">
                                    <v-icon class="mr-2 v-icon-size" color="primary">mdi-plus-circle-outline</v-icon>
                                </v-btn>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <div class="d-flex align-center">
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editActivity(item)">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:item.allowregistration="{ item }">
                            <div class="d-flex align-center">
                                <v-btn color="primary" text @click="openregistrationdailog(item)">
                                    <u>{{ item.activity_registration_count }} </u></v-btn
                                >
                                <span v-if="item.allowregistration">
                                    <v-btn icon small>
                                        <v-icon
                                            class="mr-2 v-icon-size"
                                            color="primary"
                                            @click="openregistrationdailog(item)"
                                            >mdi-plus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </div>
                        </template>
                        <template v-slot:item.session="{ item }">
                            <span v-if="item.is_multiple_sessions_allowed">
                                <div class="d-flex align-center">
                                    <v-btn color="primary" text @click="opensessiondailog(item)">
                                        <u>{{ item.activity_session_count }} </u></v-btn
                                    >
                                    <v-btn icon small>
                                        <v-icon
                                            class="mr-2 v-icon-size"
                                            color="primary"
                                            @click="opensessiondailog(item)"
                                            >mdi-plus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </div>
                            </span>
                            <span v-else>
                                <v-icon class="ml-10 pl-5 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.approval="{ item }">
                            <v-btn
                                v-if="item.activity_registration_count!=0 && item.activity_session_count!=0"
                                icon
                                small
                                @click="openApprovalDialog(item)"
                            >
                                <v-icon color="primary">mdi-login</v-icon>
                            </v-btn>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.attendance="{ item }">
                            <span v-if="item.is_attendance_required">
                                <v-btn
                                    v-if="item.activity_registration_count!=0 && item.activity_session_count!=0"
                                    icon
                                    small
                                    @click="openAttendanceDialog(item)"
                                >
                                    <v-icon color="primary">mdi-account-multiple-plus</v-icon>
                                </v-btn>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </span>
                            <span v-else>
                                <v-icon class="v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="venueDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span>Venue</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="venueDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text> {{ selectedVenue }} </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="venueDialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="activityUrlDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span>Activity URL</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="activityUrlDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text> {{ selectedActivityUrl }} </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="activityUrlDialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="descriptionDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span>Description</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="descriptionDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text> {{ selectedDescription }} </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="descriptionDialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="feeStructureDialog" max-width="900px">
            <v-card>
                <v-card-title>
                    <span>Fee Structure</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="feeStructureDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <strong>Activity Title:</strong> {{ slectedActivity.title || '-' }}
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <strong>Category:</strong> {{ slectedActivity.category || '-' }}
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <strong>Academic Year:</strong> {{ slectedActivity.ay || '-' }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Start date:</strong> {{ slectedActivity.start_date || '-' }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>End date:</strong> {{ slectedActivity.end_date || '-' }}
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <center><strong>Add New Fee Structure</strong></center>
                    <v-row dense justify="center" v-if="slectedActivity!=null">
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field
                                v-model="fee_amount"
                                label="Fee Amount"
                                type="number"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select
                                v-model="acttivity_comp"
                                :items="slectedActivity.activity_comp_data_list"
                                item-text="name"
                                item-value="id"
                                label="Select Component"
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select
                                v-model="participant_type"
                                :items="participant_type_data_list"
                                item-text="name"
                                item-value="id"
                                label="Select Participant Type"
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select
                                v-model="affiliation_type"
                                :items="affiliation_type_data_list"
                                item-text="name"
                                item-value="id"
                                label="Select Affiliation Type"
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-btn
                            color="primary"
                            v-if="affiliation_type && participant_type && acttivity_comp && fee_amount >= 0"
                            small
                            @click="addFeeStructure(slectedActivity.id)"
                            >Add / Update Fee Structure</v-btn
                        >
                    </v-row>
                    <br />
                    <v-divider></v-divider>
                    <center v-if="slectedActivity.fees_structure_list!=''">
                        <strong>Fee Structure Details</strong>
                    </center>
                    <v-data-table
                        v-if="slectedActivity.fees_structure_list!=''"
                        :headers="fees_structure_headers"
                        :items="slectedActivity.fees_structure_list"
                        class="elevation-1 mytable"
                        dense
                    >
                        <template v-slot:item.delete="{ item }">
                            <div>
                                <v-avatar size="20" class="delete-avatar ml-2">
                                    <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="feeStructureDialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="registartionDialog" max-width="2000px">
            <v-card>
                <v-card-title>
                    <span>Activity Registartion</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="registartionDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <strong>Activity Title:</strong> {{ slectedActivity.title || '-' }}
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <strong>Category:</strong> {{ slectedActivity.category || '-' }}
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <strong>Academic Year:</strong> {{ slectedActivity.ay || '-' }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Start date:</strong> {{ slectedActivity.start_date || '-' }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>End date:</strong> {{ slectedActivity.end_date || '-' }}
                        </v-col>
                    </v-row>
                </v-col>
                <span v-if="slectedActivity!=null">
                    <center>
                        <v-btn
                            v-if="slectedActivity.allowregistration"
                            color="primary"
                            @click="newRegistartionDialog=true;registration_fee_amount = slectedActivity.total_fees_amount"
                            small
                            >Add New Registration</v-btn
                        >
                    </center>
                    <br />
                    <v-divider></v-divider>

                    <v-card class="box" v-if="slectedActivity.activity_registartion_list">
                        <center v-if="slectedActivity.activity_registartion_list">
                            <strong>Registration Details</strong>
                        </center>
                        <v-data-table
                            v-if="slectedActivity.activity_registartion_list"
                            :headers="activity_registration_headers"
                            :items="slectedActivity.activity_registartion_list"
                            class="elevation-1 mytable"
                            dense
                        >
                            <template v-slot:item.receipt_no="{ item }">
                                <a href="#" @click.prevent="openReceipt(item)"> {{ item.receipt_no }} </a>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <div>
                                    <v-avatar style="" size="25" class="edit-avatar">
                                        <v-icon class="edit-v-icon mr-2" @click="editRegistration(item)">edit</v-icon>
                                    </v-avatar>
                                </div>
                            </template>
                            <template v-slot:item.is_approved="{ item }">
                                <span v-if="item.is_approved">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.is_registration_cancelled="{ item }">
                                <span v-if="item.is_registration_cancelled">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.is_payment_done="{ item }">
                                <span v-if="item.is_payment_done">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                        </v-data-table>
                    </v-card>
                </span>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="registartionDialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="sessionDialog" max-width="2000px">
            <v-card>
                <v-card-title>
                    <span>Activity Session</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="sessionDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <strong>Activity Title:</strong> {{ slectedActivity.title || '-' }}
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <strong>Category:</strong> {{ slectedActivity.category || '-' }}
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <strong>Academic Year:</strong> {{ slectedActivity.ay || '-' }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>Start date:</strong> {{ slectedActivity.start_date || '-' }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <strong>End date:</strong> {{ slectedActivity.end_date || '-' }}
                        </v-col>
                    </v-row>
                </v-col>
                <span v-if="slectedActivity!=null">
                    <center>
                        <v-btn color="primary" @click="newSessionDialog=true;" small>Add New Session</v-btn>
                        <v-btn color="primary" class="ml-2" @click="importSessionDialog=true;" small
                            >Import New Session</v-btn
                        >
                    </center>
                    <br />
                    <v-divider></v-divider>

                    <v-card class="box" v-if="slectedActivity.activity_session_data_list">
                        <center v-if="slectedActivity.activity_session_data_list">
                            <strong>Session Details</strong>
                        </center>
                        <v-data-table
                            v-if="slectedActivity.activity_session_data_list"
                            :headers="activity_session_headers"
                            :items="slectedActivity.activity_session_data_list"
                            class="elevation-1 mytable"
                            dense
                        >
                            <template v-slot:item.action="{ item }">
                                <div>
                                    <v-avatar style="" size="25" class="edit-avatar">
                                        <v-icon class="edit-v-icon mr-2" @click="editSession(item)">edit</v-icon>
                                    </v-avatar>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card>
                </span>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="sessionDialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="attendanceDialog" max-width="2000px">
            <v-card>
                <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                    <v-card class="box">
                        <v-card-title>
                            <span>Activity Attendance</span>

                            <v-spacer></v-spacer>

                            <v-btn icon @click="attendanceDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="6" md="6">
                                    <strong>Activity Title:</strong> {{ slectedActivity.title || '-' }}
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <strong>Category:</strong> {{ slectedActivity.category || '-' }}
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <strong>Academic Year:</strong> {{ slectedActivity.ay || '-' }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <strong>Start date:</strong> {{ slectedActivity.start_date || '-' }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <strong>End date:</strong> {{ slectedActivity.end_date || '-' }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-row dense justify="center" v-if="slectedActivity!=null">
                            <v-col cols="12" sm="6" md="6">
                                <div class="d-flex align-center">
                                    <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                    <v-autocomplete
                                        color="#0F2027"
                                        dense
                                        required
                                        v-model="att_session"
                                        return-object
                                        :items="slectedActivity.activity_session_data_list"
                                        item-text="session"
                                        label="Select Session"
                                    />
                                </div>
                            </v-col>
                        </v-row>
                        <v-row dense justify="center" v-if="att_session">
                            <v-btn color="primary" class="ml-2" @click="importAttendanceDialog=true;" small
                                >Import Attendance</v-btn
                            >
                            <v-card class="box">
                                <v-data-table
                                    v-model="selectedTasks"
                                    item-key="id"
                                    :single-select="singleSelect"
                                    show-select
                                    :headers="activity_attendance_headers"
                                    :items="att_session.session_attendance_details"
                                    class="elevation-1 mytable"
                                    dense
                                >
                                    <template v-slot:item.ispresent="{ item }">
                                        <v-row dense>
                                            <v-switch
                                                v-model="item.ispresent"
                                                :color="item.ispresent ? 'success' : 'primary'"
                                            ></v-switch>
                                            <span v-if="item.ispresent">
                                                <v-icon class="v-icon-size pt-5 pl-2" color="success"
                                                    >mdi-check-circle-outline</v-icon
                                                >
                                            </span>
                                            <span v-else>
                                                <v-icon class="v-icon-size pt-5 pl-2" color="error"
                                                    >mdi-close-circle-outline</v-icon
                                                >
                                            </span>
                                        </v-row>
                                    </template>
                                    <template v-slot:item.attended_duration="{ item }">
                                        <v-text-field
                                            v-model="item.attended_duration"
                                            type="number"
                                            label="Attended Hours"
                                            required
                                        ></v-text-field>
                                    </template>
                                </v-data-table>
                                <br />
                                <center>
                                    <v-btn
                                        color="primary"
                                        small
                                        v-if="selectedTasks"
                                        @click="updateAttendance(selectedTasks)"
                                        >Update Attendance</v-btn
                                    >
                                </center>
                            </v-card>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="attendanceDialog = false"> Close </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="approvalDialog" max-width="2000px">
            <v-card>
                <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                    <v-card class="box">
                        <v-card-title>
                            <span>Activity Approval</span>

                            <v-spacer></v-spacer>

                            <v-btn icon @click="approvalDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-col cols="12" sm="12" md="12" v-if="slectedActivity!=null">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="6" md="6">
                                    <strong>Activity Title:</strong> {{ slectedActivity.title || '-' }}
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <strong>Category:</strong> {{ slectedActivity.category || '-' }}
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <strong>Academic Year:</strong> {{ slectedActivity.ay || '-' }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <strong>Start date:</strong> {{ slectedActivity.start_date || '-' }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <strong>End date:</strong> {{ slectedActivity.end_date || '-' }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-row dense justify="center">
                            <v-card class="box">
                                <v-data-table
                                    v-model="selectedTasks"
                                    item-key="id"
                                    :single-select="singleSelect"
                                    show-select
                                    :headers="activity_approval_headers"
                                    :items="slectedActivity.activity_registartion_list"
                                    class="elevation-1 mytable"
                                    dense
                                >
                                    <template v-slot:item.is_approved="{ item }">
                                        <v-row dense>
                                            <v-switch
                                                v-model="item.is_approved"
                                                :color="item.is_approved ? 'success' : 'primary'"
                                            ></v-switch>
                                            <span v-if="item.is_approved">
                                                <v-icon class="v-icon-size pt-5 pl-2" color="success"
                                                    >mdi-check-circle-outline</v-icon
                                                >
                                            </span>
                                            <span v-else>
                                                <v-icon class="v-icon-size pt-5 pl-2" color="error"
                                                    >mdi-close-circle-outline</v-icon
                                                >
                                            </span>
                                        </v-row>
                                    </template>
                                    <template v-slot:item.remark="{ item }">
                                        <v-text-field v-model="item.remark" label="Remark" required></v-text-field>
                                    </template>
                                </v-data-table>
                                <br />
                                <center class="d-flex align-center justify-center mt-4">
                                        <v-btn
                                            color="primary"
                                            small
                                            v-if="selectedTasks"
                                            @click="updateApproval(selectedTasks)"
                                            >Update Approval
                                        </v-btn>

                                        <!-- Dynamic Certificate Type Dropdown -->
                                        <v-select
                                            v-if="selectedTasks && selectedTasks.length > 0"
                                            v-model="selected_cert_type"
                                            :items="certificate_type_list"
                                            item-text="name"
                                            item-value="id"
                                            label="Select Certificate Type"
                                            dense
                                            outlined
                                            hide-details
                                            style="max-width: 250px; margin-left: 20px;"
                                        ></v-select>

                                        <v-btn
                                            color="primary"
                                            small
                                            v-if="selectedTasks"
                                            :disabled="selectedTasks.length === 0 || !selected_cert_type"
                                            style="margin-left: 20px;"
                                            @click="generateBulkCertificate(selectedTasks)"
                                            >Generate Bulk Certificate
                                        </v-btn>
                                    </center>
                                                                </v-card>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="approvalDialog = false"> Close </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" hide-overlay persistent width="1100">
            <v-card>
                <v-card-title>Add/Update Activity</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-text-field
                                    v-model="new_activity_name"
                                    label="Activity Title"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-select
                                    v-model="new_activity_category"
                                    :items="activity_category_list"
                                    item-text="name"
                                    return-object
                                    label="Activity Category"
                                    requiresd
                                ></v-select>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="activity_ay"
                                    return-object
                                    :items="ay_std_div_list"
                                    item-text="ay"
                                    label="Select Academic Year"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="from_date"
                                            label="Activity Start Date"
                                            append-icon="mdi-calendar"
                                            dense
                                        />
                                    </template>
                                    <v-date-picker v-model="from_date" @input="menu1 = false" />
                                </v-menu>
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12 ml-2">*</v-icon>
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="to_date"
                                            label="Activity End Date"
                                            append-icon="mdi-calendar"
                                            dense
                                        />
                                    </template>
                                    <v-date-picker v-model="to_date" :min="from_date" @input="menu2 = false" />
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-menu
                                    v-model="menu3"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="reg_from_date"
                                            label="Activity Registration Start Date"
                                            append-icon="mdi-calendar"
                                            dense
                                        />
                                    </template>
                                    <v-date-picker v-model="reg_from_date" @input="menu3 = false" />
                                </v-menu>
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12 ml-2">*</v-icon>
                                <v-menu
                                    v-model="menu5"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="reg_to_date"
                                            label="Activity Registration End Date"
                                            append-icon="mdi-calendar"
                                            dense
                                        />
                                    </template>
                                    <v-date-picker v-model="reg_to_date" :min="reg_from_date" @input="menu5 = false" />
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="activity_inst"
                                    item-value="id"
                                    :items="inst_list"
                                    item-text="name"
                                    label="Select Co-ordinator"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="total_hours"
                                    type="number"
                                    label="Total Hours"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="max_participants"
                                    type="number"
                                    label="Max Participants"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="max_feedback_rating"
                                    type="number"
                                    label="Max Feedback Rating"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="certificate_prefix"
                                    type="text"
                                    label="Certificate Prefix"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-textarea
                                    v-model="activity_description"
                                    label=" Description"
                                    rows="3"
                                    required
                                ></v-textarea>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-textarea v-model="activity_venue" label=" Venue" rows="3" required></v-textarea>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="activity_url"
                                    type="text"
                                    label="Activity URL"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-switch v-model="isactive" label="Is Active ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch v-model="attendance_required" label="Attendance Required ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch v-model="certificate_enabled" label="Certificate Enabled ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch v-model="feedback_enabled" label="Feedback Enabled ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch v-model="fee_applicable" label="Fee Applicable ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch v-model="appraisal_linked" label="Appraisal Linked ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch v-model="approval_required" label="Approval Required ?"></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <div class="d-flex align-center">
                                <v-switch
                                    v-model="is_multiple_sessions_allowed"
                                    label="Is Multiple Sessions Allowed ?"
                                ></v-switch>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="!is_multiple_sessions_allowed">
                            <div class="d-flex align-center">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="resource_person"
                                    item-value="id"
                                    :items="resource_person_list"
                                    item-text="resource_person_name"
                                    label="Select Resource Person"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <center>
                    <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="addNewActivity()">Save</v-btn>
                </center>
            </v-card>
        </v-dialog>
        <v-dialog v-model="newRegistartionDialog" hide-overlay persistent width="1100">
            <v-card>
                <v-card-title>Add / Update Registration</v-card-title>
                <v-card-text>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6" v-if="edited_item == 0">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="reg_participant_type"
                                    return-object
                                    :items="participant_type_data_list"
                                    item-text="name"
                                    label="Select Participant Type"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-else
                            ><strong>Participant Type:</strong>{{ reg_participant_type }}</v-col
                        >
                        <v-col cols="12" sm="6" md="6" v-if="edited_item == 0">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="affiliation_type"
                                    item-value="id"
                                    :items="affiliation_type_data_list"
                                    item-text="name"
                                    label="Select Affiliation Type"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-else
                            ><strong>Affiliation Type:</strong>{{ affiliation_type }}</v-col
                        >
                        <v-col cols="12" sm="6" md="6" v-if="reg_participant_type">
                            <div class="d-flex align-center">
                                <v-autocomplete
                                    v-if="reg_participant_type.name=='Student'"
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="registration_learner"
                                    return-object
                                    :items="learner_list"
                                    item-text="name"
                                    label="Select Student"
                                />
                                <v-autocomplete
                                    v-else-if="reg_participant_type.name=='Parent'"
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="registration_parent"
                                    return-object
                                    :items="parent_list"
                                    item-text="name"
                                    label="Select Parent"
                                />
                                <v-autocomplete
                                    v-else
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="registraion_inst"
                                    return-object
                                    :items="inst_list"
                                    item-text="name"
                                    label="Select Employee"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="payment_mode"
                                    return-object
                                    :items="payment_mode_list"
                                    item-text="name"
                                    label="Select Payment Mode"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="registration_name"
                                    type="text"
                                    label="Name"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="registration_mobile_number"
                                    type="number"
                                    label="Mobile"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="registration_email"
                                    type="text"
                                    label="Email"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="registration_org_name"
                                    type="text"
                                    label="Organization Name"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-text-field
                                    readonly
                                    v-model="registration_fee_amount"
                                    type="number"
                                    label="Fee Amount"
                                    required
                                ></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <center>
                    <v-btn color="blue darken-1" text @click="close_reg_dialog()">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="addNewRegistration()">Save</v-btn>
                </center>
            </v-card>
        </v-dialog>
        <v-dialog v-model="newSessionDialog" hide-overlay persistent width="1100">
            <v-card>
                <v-card-title>Add / Update Session</v-card-title>
                <v-card-text>
                    <v-row dense justify="center">
                        <!-- <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-text-field
                                    v-model="session_no"
                                    type="number"
                                    label="Session No."
                                    required
                                ></v-text-field>
                            </div>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="6" v-if="slectedActivity">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-menu
                                    v-model="menu_session_start_date"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="session_start_date"
                                            label="Session Start Date"
                                            append-icon="mdi-calendar"
                                            dense
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="session_start_date"
                                        :min="slectedActivity.start_date_edit"
                                        :max="slectedActivity.end_date_edit"
                                        @input="menu_session_start_date = false"
                                    />
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="slectedActivity">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-menu
                                    v-model="menu_session_end_date"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="session_end_date"
                                            label="Session End Date"
                                            append-icon="mdi-calendar"
                                            dense
                                        />
                                    </template>
                                    <v-date-picker
                                        :min="slectedActivity.start_date_edit"
                                        :max="slectedActivity.end_date_edit"
                                        v-model="session_end_date"
                                        @input="menu_session_end_date = false"
                                    />
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-menu
                                    v-model="menu_session_start_time"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="session_start_time"
                                            label="Session Start Time"
                                            append-icon="mdi-clock"
                                            dense
                                        />
                                    </template>
                                    <v-time-picker
                                        v-model="session_start_time"
                                        @input="menu_session_start_time = false"
                                    />
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-icon color="error" size="small" class="mr-1 mb-12">*</v-icon>
                                <v-menu
                                    v-model="menu_session_end_time"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="session_end_time"
                                            label="Session End Time"
                                            append-icon="mdi-clock"
                                            dense
                                        />
                                    </template>
                                    <v-time-picker v-model="session_end_time" @input="menu_session_end_time = false" />
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    required
                                    v-model="resource_person"
                                    :items="resource_person_list"
                                    item-text="resource_person_name"
                                    return-object
                                    label="Select Resource Person"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <div class="d-flex align-center">
                                <v-textarea
                                    v-model="session_description"
                                    label=" Description"
                                    rows="3"
                                    required
                                ></v-textarea>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <center>
                    <v-btn color="blue darken-1" text @click="closeSessionDialog()">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="addNewSession()">Save</v-btn>
                </center>
            </v-card>
        </v-dialog>
        <v-dialog v-model="importSessionDialog" max-width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Import Marks Entry </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn small rounded @click="importSessionDialog = false">Close</v-btn>
                    </v-toolbar>
                    <v-row justify="center" v-if="slectedActivity">
                        <v-col lg="5" sm="6" md="6" cols="6">
                            <v-avatar color="#E8EAF6"> 1</v-avatar>
                            <span
                                style="
                                    margin-left: 10px;
                                    font-size: 15px;
                                    color: blue;
                                    text-decoration: underline;
                                    cursor: pointer;
                                "
                                @click="exportTableToCSV(`${slectedActivity.title}_${slectedActivity.ay}_${slectedActivity.start_date}_${slectedActivity.end_date}.csv`)"
                            >
                                Download CSV / Excel Upload Template
                                <v-icon>mdi-download</v-icon>
                            </span></v-col
                        >
                        <v-col lg="3" sm="6" md="6">
                            <v-avatar color="#E8EAF6"> 2</v-avatar>
                            <span style="margin-left: 10px; font-size: 15px">Prepare Excel File</span> </v-col
                        ><v-col lg="3" sm="6" md="6">
                            <v-avatar color="#E8EAF6"> 3</v-avatar>
                            <span style="margin-left: 10px; font-size: 15px">Start Upload</span>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="4" md="4">
                            <v-file-input
                                density="compact"
                                variant="outlined"
                                label="Select File"
                                v-model="file"
                                accept=".csv"
                                show-size
                                :rules="[(v) => !!v || 'File Required']"
                            ></v-file-input>
                            <template #label>
                                <p>Select File<span style="color: red">*</span></p>
                            </template>
                        </v-col>
                        <v-col cols="12" sm="12" align="center">
                            <v-btn
                                class="button"
                                @click="importSession(slectedActivity.id)"
                                :disabled="!file"
                                :loading="uploading"
                            >
                                UPLOAD
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="mt-5 mb-5 ml-5 mr-5 yellow-card">
                        <v-col cols="12" sm="12" md="12">
                            <b>Guidelines</b>
                            <ol style="line-height: 30px">
                                <li>The file must be in <strong>CSV</strong> format.</li>

                                <li>
                                    The first row of the file must contain the header labels. EduplusSchool uses these
                                    headers to map the data correctly and ensure a successful import.
                                </li>

                                <li>
                                    Each row must contain Session Start Date and Session End Date. Session Start Date
                                    must be a greater than or equal to activity start date and Session End Date must be
                                    a less than or equal to activity end date.
                                </li>

                                <li>
                                    Each row must contain the Session Start Time and Session End Time in HH (Hour):MM
                                    (Minute) format.
                                </li>
                            </ol>
                        </v-col>
                    </v-row>
                    <table id="example" style="display: none; font-weight: bold">
                        <thead>
                            <tr>
                                <th>Session Start Date(DD/MM/YYYY)</th>
                                <th>Session End Date(DD/MM/YYYY)</th>
                                <th>Start Time(HH:MM)</th>
                                <th>End Time(HH:MM)</th>
                                <th>Resource Person(Employee Code(Not Cumpulsary))</th>
                                <th>Description(Not Cumpulsary)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>12/06/2026</td>
                                <td>12/06/2026</td>
                                <td>09:30</td>
                                <td>18:30</td>
                                <td>SBPPS0001P</td>
                                <td>Session-01</td>
                            </tr>
                        </tbody>
                    </table>
                    <center>
                        <v-btn rounded class="button" @click="importSessionDialog = false">Close</v-btn>
                    </center>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog v-model="feedbackSummaryDialog" max-width="1200px" scrollable>
            <v-card>

                <v-card-title>
                    <strong>Feedback Summary</strong>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="feedbackSummaryDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row dense justify="center" v-if="feedbackSummaryActivity">

                        <v-col cols="12" sm="6">
                            <strong class="feedback_data_title">Activity Title:</strong>
                            {{ feedbackSummaryActivity.title || '-' }}
                        </v-col>

                        <v-col cols="12" sm="3">
                            <strong class="feedback_data_title">Category:</strong>
                            {{ feedbackSummaryActivity.category || '-' }}
                        </v-col>

                        <v-col cols="12" sm="3">
                            <strong class="feedback_data_title">Feedback Average:</strong>
                            <span class="feedback-average">
                                {{ feedbackAverage }}
                            </span>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <strong class="feedback_data_title">Academic Year:</strong>
                            {{ feedbackSummaryActivity.ay || '-' }}
                        </v-col>

                        <v-col cols="12" sm="3">
                            <strong class="feedback_data_title">Start Date:</strong>
                            {{ feedbackSummaryActivity.start_date || '-' }}
                        </v-col>

                        <v-col cols="12" sm="3">
                            <strong class="feedback_data_title">End Date:</strong>
                            {{ feedbackSummaryActivity.end_date || '-' }}
                        </v-col>

                    </v-row>

                    <br>

                    <v-divider></v-divider>

                    <br>

                    <!-- FEEDBACK TABLE -->
                    <center>
                        <strong style="font-size: 16px;color: black;">Feedback Details</strong>
                    </center>

                    <v-data-table :headers="[
                        {
                            text: 'Participant Name',
                            value: 'participant_name'
                        },
                        {
                            text: 'Employee Code / PRN',
                            value: 'registration_number'
                        },
                        {
                            text: 'Affiliation Type',
                            value: 'affiliation_type'
                        },
                        {
                            text: 'Participant Type',
                            value: 'participant_type'
                        },
                        {
                            text: 'Rating',
                            value: 'rating'
                        },
                        {
                            text: 'Comments',
                            value: 'comments'
                        },
                        {
                            text: 'Feedback Date',
                            value: 'feedback_date'
                        }
                    ]" :items="activity_feedback_list" class="elevation-1 mytable" dense>

                        <template v-slot:item.participant_name="{ item }">

                            {{
                                item.participant_name ||
                                (
                                    activity_feedback_registration_list.length > 0
                                        ? activity_feedback_registration_list[0].name
                                        : '-'
                                )
                            }}

                        </template>

                        <!-- EMPLOYEE CODE / PRN -->
                        <template v-slot:item.registration_number="{ item }">

                            {{
                                activity_feedback_registration_list.length > 0 &&
                                    activity_feedback_registration_list[0].learner_id &&
                                    activity_feedback_registration_list[0].learner_id.registration_number
                                    ? activity_feedback_registration_list[0].learner_id.registration_number
                                    : '-'
                            }}

                        </template>

                        <!-- AFFILIATION TYPE -->
                        <template v-slot:item.affiliation_type="{ item }">

                            {{
                                activity_feedback_registration_list.length > 0
                                    ? activity_feedback_registration_list[0].affiliation_type
                                    : '-'
                            }}

                        </template>

                        <!-- PARTICIPANT TYPE -->
                        <template v-slot:item.participant_type="{ item }">

                            {{
                                activity_feedback_registration_list.length > 0
                                    ? activity_feedback_registration_list[0].participant_type
                                    : '-'
                            }}

                        </template>

                        <!-- RATING -->
                        <template v-slot:item.rating="{ item }">

                            {{ item.rating || '-' }}

                        </template>

                        <!-- COMMENTS -->
                        <template v-slot:item.comments="{ item }">

                            {{ item.comments || '-' }}

                        </template>

                        <!-- FEEDBACK DATE -->
                        <template v-slot:item.feedback_date="{ item }">

                            {{ item.feedback_date || '-' }}

                        </template>

                        <!-- NO DATA -->
                        <template v-slot:no-data>
                            No feedback available
                        </template>

                    </v-data-table>

                </v-card-text>

                <!-- FOOTER -->
                <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn color="primary" @click="feedbackSummaryDialog = false">
                        Close
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
        <v-dialog v-model="importAttendanceDialog" max-width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Import Marks Entry </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn small rounded @click="importAttendanceDialog = false">Close</v-btn>
                    </v-toolbar>
                    <v-row justify="center" v-if="slectedActivity">
                        <v-col lg="5" sm="6" md="6" cols="6">
                            <v-avatar color="#E8EAF6"> 1</v-avatar>
                            <span
                                style="
                                    margin-left: 10px;
                                    font-size: 15px;
                                    color: blue;
                                    text-decoration: underline;
                                    cursor: pointer;
                                "
                                @click="exportTableToCSVAtt(`${slectedActivity.title}_${slectedActivity.ay}_${att_session.session}.csv`)"
                            >
                                Download CSV / Excel Upload Template
                                <v-icon>mdi-download</v-icon>
                            </span></v-col
                        >
                        <v-col lg="3" sm="6" md="6">
                            <v-avatar color="#E8EAF6"> 2</v-avatar>
                            <span style="margin-left: 10px; font-size: 15px">Prepare Excel File</span> </v-col
                        ><v-col lg="3" sm="6" md="6">
                            <v-avatar color="#E8EAF6"> 3</v-avatar>
                            <span style="margin-left: 10px; font-size: 15px">Start Upload</span>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="4" md="4">
                            <v-file-input
                                density="compact"
                                variant="outlined"
                                label="Select File"
                                v-model="file"
                                accept=".csv"
                                show-size
                                :rules="[(v) => !!v || 'File Required']"
                            ></v-file-input>
                            <template #label>
                                <p>Select File<span style="color: red">*</span></p>
                            </template>
                        </v-col>
                        <v-col cols="12" sm="12" align="center">
                            <v-btn
                                class="button"
                                @click="importAttendance(slectedActivity.id,att_session.id)"
                                :disabled="!file"
                                :loading="uploading"
                            >
                                UPLOAD
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="mt-5 mb-5 ml-5 mr-5 yellow-card">
                        <v-col cols="12" sm="12" md="12">
                            <b>Guidelines</b>
                            <ol style="line-height: 30px">
                                <li>The file must be in <strong>CSV</strong> format.</li>

                                <li>
                                    The first row of the file must contain the header labels. EduplusSchool uses these
                                    headers to map the data correctly and ensure a successful import.
                                </li>

                                <li>
                                    In the <strong>Is Present?</strong> column, enter <strong>AB</strong> if the
                                    participant is absent and <strong>P</strong> if the participant is present.
                                </li>

                                <li>
                                    If a participant is absent, enter <strong>AB</strong> in the
                                    <strong>Is Present?</strong> column and enter <strong>0</strong> as the attendance
                                    duration.
                                </li>

                                <li>
                                    Each row must contain the <strong>Attendance Duration</strong> in
                                    <strong>HH (Hour):MM (Minute)</strong> format.
                                </li>
                            </ol>
                        </v-col>
                    </v-row>
                    <table v-if="att_session" id="example1" style="display: none; font-weight: bold">
                        <thead>
                            <tr>
                                <th style="text-align: center">Sr. No.</th>
                                <th>Participant Name</th>
                                <th>Is Present?</th>
                                <th>Total Duration(Hrs)</th>
                                <th>Attended Duration(Hrs)</th>
                                <th>Participant Email</th>
                                <th>Participant Mobile</th>
                                <th>Organization Name</th>
                                <th>Learner</th>
                                <th>Parent</th>
                                <th>Instructor</th>
                                <th>Participant Type</th>
                                <th>Affiliation Type</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item) in att_session.session_attendance_details" :key="item.id">
                                <td style="text-align: center">{{ item.srno }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.present_status }}</td>
                                <td>{{ item.duration_in_hours }}</td>
                                <td>{{item.attended_duration}}</td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.mobile }}</td>
                                <td>{{ item.organization_name }}</td>
                                <td>{{ item.learner }}</td>
                                <td>{{ item.parent }}</td>
                                <td>{{ item.instructor }}</td>
                                <td>{{ item.participant_type }}</td>
                                <td>{{ item.affiliation_type }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <center>
                        <v-btn rounded class="button" @click="importAttendanceDialog = false">Close</v-btn>
                    </center>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_delete" max-width="1000px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Delete Fee Structure </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_delete = false"
                        ><v-icon> mdi-close </v-icon></v-btn
                    >
                </v-toolbar>
                <center>
                    <strong>Are you sure you want delete this fee structure???</strong>
                </center>
                <v-row justify="center">
                    <v-btn class="button" text @click="dialog_delete = false">No</v-btn>
                    <v-btn class="button" text @click="deleteFeeStructureItem()">Yes</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="certificateListDialog" max-width="1200px" scrollable>
    <v-card>
        <v-card-title>
            <strong>Certificate List</strong>
            <v-spacer></v-spacer>
            <v-btn icon @click="certificateListDialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        
        <v-divider></v-divider>
        
        <v-card-text>
            <v-row dense justify="center" v-if="slectedActivity" class="mt-4 mb-6">
                <v-col cols="12">
                    <table class="feedback-summary-table" style="width: 100%;">
                        <thead>
                            <tr>
                                <th>Activity Title</th>
                                <th>Category</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Academic Year</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ slectedActivity.title || '-' }}</td>
                                <td>{{ slectedActivity.category || '-' }}</td>
                                <td>{{ slectedActivity.start_date || '-' }}</td>
                                <td>{{ slectedActivity.end_date || '-' }}</td>
                                <td>{{ slectedActivity.ay || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-col>
            </v-row>

            <v-row dense justify="end" align="center" class="mb-4">
                <v-col cols="12" sm="4">
                    <v-text-field
                        v-model="certificate_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        dense
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="auto" class="d-flex align-center">
                     <v-btn icon><v-icon>mdi-file-excel</v-icon></v-btn>
                     <v-btn icon><v-icon>mdi-download</v-icon></v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :headers="certificate_list_headers"
                :items="certificate_list"
                :search="certificate_search"
                class="elevation-1 mytable"
                dense
            >
                <template v-slot:item.view="{ item }">
                    <v-btn icon small @click="viewCertificate(item)">
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="certificateListDialog = false">Close</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="text-center">
            <v-dialog v-model="output_load" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
    export default {
        components: {
            Breadcrumbs,
        },
        data() {
            return {
                singleSelect: false,
                selectedTasks: [],
                reg_participant_type: null,
                registraion_inst: null,
                registration_learner: null,
                selected_cert_type: null,
                certificate_type_list: [],
                registration_name: null,
                registration_mobile_number: null,
                registration_org_name: null,
                registration_email: null,
                registration_fee_amount: null,
                total_fees_amount: null,
                payment_mode: null,
                parent_list: [],
                registration_parent: null,
                snackbar_msg: "",
                color: "",
                output_load: false,
                snackbar: false,
                overlay: false,
                search: null,
                ay_std_div_list: null,
                sel_ay_data: null,
                loader: false,
                inst_list: [],
                activity_category_list: [],
                activity_category_list_with_all: [],
                activity_category: null,
                dialog_new: false,
                newSessionDialog: false,
                new_activity_name: null,
                new_activity_category: null,
                menu1: false,
                menu2: false,
                from_date: "",
                to_date: "",
                reg_from_date: "",
                reg_to_date: "",
                menu3: false,
                menu5: false,
                total_hours: 0,
                max_participants: 0,
                max_feedback_rating: 0,
                certificate_prefix: null,
                activity_ay: null,
                activity_inst: null,
                activity_venue: null,
                activity_description: null,
                selectedActivity: null,
                attendance_required: false,
                certificate_enabled: false,
                feedback_enabled: false,
                fee_applicable: false,
                approval_required: false,
                appraisal_linked: false,
                is_multiple_sessions_allowed: false,
                activity_data_list: [],
                venueDialog: false,
                descriptionDialog: false,
                feeStructureDialog: false,
                slectedActivity: null,
                selectedVenue: "",
                selectedDescription: "",
                acttivity_comp: null,
                participant_type_data_list: [],
                participant_type: null,
                affiliation_type_data_list: [],
                affiliation_type: null,
                activity_url: null,
                dialog_delete: false,
                selecteddeleteFeeStructureItem: null,
                selectedActivityUrl: null,
                activityUrlDialog: false,
                sessionDialog: false,
                fee_amount: 0,
                isactive: true,
                activity_id: null,
                registartionDialog: false,
                activityFeedbackDialog: false,
                activity_feedback_list: [],
                activity_feedback_registration_list: [],
                selectedFeedbackActivity: {},
                payment_mode_list: [],
                payment_mode: null,
                learner_list: [],
                registration_id: null,
                newRegistartionDialog: false,
                edited_item: 0,
                resource_person_list: [],
                resource_person: null,
                session_id: null,
                session_start_date: null,
                session_end_date: null,
                session_start_time: null,
                session_end_time: null,
                session_description: null,
                menu_session_start_date: false,
                menu_session_end_date: false,
                menu_session_start_time: false,
                menu_session_end_time: false,
                attendanceDialog: false,
                att_session: null,
                org_basic_data: null,
                approvalDialog: false,
                importAttendanceDialog: false,
                importSessionDialog: false,
                feedbackSummaryDialog:false,
                feedbackSummaryActivity: null,
                certificateListDialog: false,
                certificate_search: "",
                certificate_list: [],
                file: null,
                activity_session_headers: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                        align: "center",
                    },

                    {
                        text: "Session No.",
                        value: "session_no",
                    },

                    {
                        text: "Session Start Date",
                        value: "session_start_date",
                    },
                    {
                        text: "Session End Date",
                        value: "session_end_date",
                    },

                    {
                        text: "Start Time",
                        value: "start_time",
                    },

                    {
                        text: "End Time",
                        value: "end_time",
                    },
                    {
                        text: "Duration (Minutes)",
                        value: "duration_in_minutes",
                    },
                    {
                        text: "Resource Person",
                        value: "resourceperson",
                    },
                    {
                        text: "Description",
                        value: "description",
                    },
                    {
                        text: "Action",
                        value: "action",
                        align: "center",
                    },
                ],
                activity_registration_headers: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                        align: "center",
                    },

                    {
                        text: "Participant Name",
                        value: "name",
                    },

                    {
                        text: "Participant Email",
                        value: "email",
                    },

                    {
                        text: "Participant Mobile",
                        value: "mobile",
                    },

                    {
                        text: "Organization Name",
                        value: "organization_name",
                    },

                    {
                        text: "Participant Type",
                        value: "participant_type",
                    },

                    {
                        text: "Affiliation Type",
                        value: "affiliation_type",
                    },

                    {
                        text: "Receipt No.",
                        value: "receipt_no",
                    },

                    {
                        text: "Remark",
                        value: "remark",
                    },

                    {
                        text: "Fees Amount",
                        value: "fees_amount",
                    },
                    {
                        text: "Registration Date",
                        value: "registration_date",
                    },

                    {
                        text: "Payment Mode",
                        value: "paymentmode",
                    },

                    {
                        text: "Learner",
                        value: "learner",
                    },

                    {
                        text: "Parent",
                        value: "parent",
                    },

                    {
                        text: "Instructor",
                        value: "instructor",
                    },

                    {
                        text: "Approved By",
                        value: "approvedby",
                    },

                    {
                        text: "Approval Date",
                        value: "approval_date",
                    },
                    {
                        text: "Payment Status",
                        value: "is_payment_done",
                    },

                    {
                        text: "Registration Status(Cancelled / Confirmed)",
                        value: "is_registration_cancelled",
                    },

                    {
                        text: "Approval Status",
                        value: "is_approved",
                    },

                    {
                        text: "Action",
                        value: "action",
                        align: "center",
                    },
                ],
                activity_approval_headers: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                        align: "center",
                    },
                    {
                        text: "Approval Status",
                        value: "is_approved",
                    },

                    {
                        text: "Participant Name",
                        value: "name",
                    },
                    {
                        text: "Total Attended Hours",
                        value: "total_attended_hr",
                    },
                    {
                        text: "Remark",
                        value: "remark",
                        width: "500px",
                    },
                    {
                        text: "Participant Email",
                        value: "email",
                    },

                    {
                        text: "Participant Mobile",
                        value: "mobile",
                    },
                    {
                        text: "Organization Name",
                        value: "organization_name",
                    },

                    {
                        text: "Participant Type",
                        value: "participant_type",
                    },

                    {
                        text: "Affiliation Type",
                        value: "affiliation_type",
                    },
                    {
                        text: "Learner",
                        value: "learner",
                    },

                    {
                        text: "Parent",
                        value: "parent",
                    },

                    {
                        text: "Instructor",
                        value: "instructor",
                    },

                    {
                        text: "Approved By",
                        value: "approvedby",
                    },

                    {
                        text: "Approval Date",
                        value: "approval_date",
                    },
                ],
                certificate_list_headers: [
                    { text: "Sr. No", value: "srno", align: "center" },
                    { text: "Affiliation Type", value: "affiliation_type" },
                    { text: "Participant Type", value: "participant_type" },
                    { text: "Employee Code / PRN", value: "employee_code" },
                    { text: "Name", value: "name" },
                    { text: "Certificate Type", value: "activitycertificatetype" },
                    { text: "Issue Date", value: "issue_date" },
                    { text: "Certificate Number", value: "certificate_number" },
                    { text: "View", value: "view", align: "center", sortable: false },
                ],
                activity_attendance_headers: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                        align: "center",
                    },

                    {
                        text: "Participant Name",
                        value: "name",
                    },
                    {
                        text: "Is present ?",
                        value: "ispresent",
                    },
                    {
                        text: "Total Duration(Hrs)",
                        value: "duration_in_hours",
                    },
                    {
                        text: "Attended Duration(Hrs)",
                        value: "attended_duration",
                    },

                    {
                        text: "Participant Email",
                        value: "email",
                    },

                    {
                        text: "Participant Mobile",
                        value: "mobile",
                    },
                    {
                        text: "Organization Name",
                        value: "organization_name",
                    },
                    {
                        text: "Learner",
                        value: "learner",
                    },
                    {
                        text: "Parent",
                        value: "parent",
                    },

                    {
                        text: "Instructor",
                        value: "instructor",
                    },
                    {
                        text: "Participant Type",
                        value: "participant_type",
                    },

                    {
                        text: "Affiliation Type",
                        value: "affiliation_type",
                    },
                ],
                fees_structure_headers: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                        align: "center",
                    },
                    {
                        text: "Amount",
                        value: "amount",
                    },
                    {
                        text: "Fee Component",
                        value: "activityfeescomponent",
                    },
                    {
                        text: "Participant Type",
                        value: "participant_type",
                    },
                    {
                        text: "Affiliation Type",
                        value: "affiliation_type",
                    },
                    {
                        text: "Delete",
                        value: "delete",
                    },
                ],
                activity_headers: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                        align: "center",
                    },
                    {
                        text: "Title",
                        value: "title",
                    },
                    {
                        text: "Category",
                        value: "category",
                    },
                    {
                        text: "Academic Year",
                        value: "ay",
                    },
                    {
                        text: "Coordinator",
                        value: "coordinator",
                    },
                    {
                        text: "Start Date",
                        value: "start_date",
                    },
                    {
                        text: "End Date",
                        value: "end_date",
                    },
                    {
                        text: "Registration Start Date",
                        value: "registration_start_date",
                    },
                    {
                        text: "Registration End Date",
                        value: "registration_end_date",
                    },
                    {
                        text: "Total Hours",
                        value: "total_hours",
                        align: "center",
                    },
                    {
                        text: "Max Participants",
                        value: "max_participants",
                        align: "center",
                    },
                    {
                        text: "Max Feedback Rating",
                        value: "max_feedback_rating",
                        align: "center",
                    },
                    {
                        text: "Fee Structure",
                        value: "fee_structure",
                        align: "center",
                    },
                    {
                        text: "Registration",
                        value: "allowregistration",
                        align: "center",
                    },
                    {
                        text: "Session",
                        value: "session",
                        align: "center",
                    },
                    {
                        text: "Attendance",
                        value: "attendance",
                        align: "center",
                    },
                    {
                        text: "Approval",
                        value: "approval",
                        align: "center",
                    },
                    {
                        text: "Activity Url",
                        value: "activity_url",
                    },
                     {
                        text: "Feedback Summary",
                        value: "feedback_summary",
                        align: "center",
                    },
                      {
                        text: "certificate_list",
                        value: "certificate",
                        align: "center",
                    },


                    {
                        text: "Venue",
                        value: "venue",
                    },
                    {
                        text: "Description",
                        value: "description",
                    },
                    {
                        text: "Isactive",
                        value: "isactive",
                        align: "center",
                    },
                    {
                        text: "Attendance Required",
                        value: "is_attendance_required",
                        align: "center",
                    },
                    {
                        text: "Certificate Enabled",
                        value: "is_certificate_enabled",
                        align: "center",
                    },
                    {
                        text: "Feedback Enabled",
                        value: "is_feedback_enabled",
                        align: "center",
                    },
                    {
                        text: "Fees Applicable",
                        value: "is_fees_applicable",
                        align: "center",
                    },
                    {
                        text: "Is Multiple Sessions Allowed",
                        value: "is_multiple_sessions_allowed",
                        align: "center",
                    },
                    {
                        text: "Approval Required",
                        value: "is_approval_required",
                        align: "center",
                    },
                    {
                        text: "Action",
                        value: "action",
                        align: "center",
                    },
                ],
            };
        },

         computed: {
        feedbackAverage() {
            if (
                !this.activity_feedback_list ||
                this.activity_feedback_list.length === 0
            ) {
                return '0.00'
            }

            const ratings = this.activity_feedback_list
                .map(item => Number(item.rating))
                .filter(rating => !isNaN(rating))

            if (ratings.length === 0) {
                return '0.00'
            }

            const total = ratings.reduce(
                (sum, rating) => sum + rating,
                0
            )

            return (total / ratings.length).toFixed(2)
        }
    },
    watch: {
    reg_participant_type: {
        handler: function() {
            this.calculateFeeAmount();
        },
        deep: true
    },
    affiliation_type: {
        handler: function() {
            this.calculateFeeAmount();
        }
    }
},

        methods: {
            openAttendanceDialog(item) {
                this.att_session = null;
                this.slectedActivity = item;
                this.attendanceDialog = true;
            },
            openApprovalDialog(item) {
                this.slectedActivity = item;
                this.approvalDialog = true;
            },
            openregistrationdailog(item) {
                this.slectedActivity = item;
                this.registartionDialog = true;
            },
             
            openFeeStructureDialog(item) {
                this.slectedActivity = item;
                this.feeStructureDialog = true;
            },
            opensessiondailog(item) {
                this.slectedActivity = item;
                this.sessionDialog = true;
            },
            openVenueDialog(item) {
                this.selectedVenue = item.venue || "-";
                this.venueDialog = true;
            },
            openActivityUrlDialog(item) {
                this.selectedActivityUrl = item.activity_url || "-";
                this.activityUrlDialog = true;
            },

            openDescriptionDialog(item) {
                this.selectedDescription = item.description || "-";
                this.descriptionDialog = true;
            },
            exportTableToCSV(filename) {
                //declare a JavaScript variable of array type
                var csv = [];
                var rows = document.querySelectorAll("#example  tr");
                var rows2 = document.getElementById("example");
                //merge the whole data in tabular form
                for (var i = 0; i < rows.length; i++) {
                    var row = [],
                        cols = rows[i].querySelectorAll("td, th");
                    for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
                    csv.push(row.join(","));
                }
                //call the function to download the CSV file
                this.downloadCSV(csv.join("\n"), filename);
            },
            exportTableToCSVAtt(filename) {
                //declare a JavaScript variable of array type
                var csv = [];
                var rows = document.querySelectorAll("#example1  tr");
                var rows2 = document.getElementById("example1");
                //merge the whole data in tabular form
                for (var i = 0; i < rows.length; i++) {
                    var row = [],
                        cols = rows[i].querySelectorAll("td, th");
                    for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
                    csv.push(row.join(","));
                }
                //call the function to download the CSV file
                this.downloadCSV(csv.join("\n"), filename);
            },
            downloadCSV(csv, filename) {
                var csvFile;
                var downloadLink;

                //define the file type to text/csv
                csvFile = new Blob([csv], { type: "text/csv" });
                downloadLink = document.createElement("a");
                downloadLink.download = filename;
                downloadLink.href = window.URL.createObjectURL(csvFile);
                downloadLink.style.display = "none";

                document.body.appendChild(downloadLink);
                downloadLink.click();
            },
            openReceipt(item) {
                localStorage.setItem("Receipt-No", item.receipt_no);
                localStorage.setItem("Activity", JSON.stringify(this.slectedActivity));
                localStorage.setItem("receiptdetails", JSON.stringify(item));
                let routeData = this.$router.resolve({
                    name: "activity-receipt",
                    query: {
                        id: item.id,
                    },
                });
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));

                window.open(routeData.href, "_blank");
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            deleteItem(item) {
                this.dialog_delete = true;
                this.selecteddeleteFeeStructureItem = item;
            },
            editSession(item) {
                (this.session_id = item.id),
                    (this.session_start_date = item.session_start_date_edit),
                    (this.session_end_date = item.session_end_date_edit),
                    (this.session_start_time = item.start_time),
                    (this.session_end_time = item.end_time),
                    (this.resource_person = item.resource_person_id),
                    (this.session_description = item.description),
                    (this.newSessionDialog = true);
            },
            editRegistration(item) {
                //  this.reg_participant_type = item.participanttype_id,
                (this.reg_participant_type = item.participant_type),
                    (this.registraion_inst = item.inst_id),
                    (this.registration_learner = item.learner_id),
                    (this.registration_name = item.name),
                    (this.registration_mobile_number = item.mobile),
                    (this.registration_org_name = item.organization_name),
                    (this.registration_email = item.email),
                    (this.registration_fee_amount = item.fees_amount),
                    (this.payment_mode = item.paymentmode_id),
                    // this.affiliation_type = item.affiliationtype_id,
                    (this.affiliation_type = item.affiliation_type),
                    (this.registration_parent = item.parent_id);
                this.newRegistartionDialog = true;
                this.edited_item = 1;
                this.registration_id = item.id;
            },
            editActivity(item) {
                this.new_activity_name = item.title;
                this.new_activity_category = item.category_id;
                this.from_date = item.start_date_edit;
                this.to_date = item.end_date_edit;
                this.reg_from_date = item.registration_start_date_edit;
                this.reg_to_date = item.registration_end_date_edit;
                this.activity_ay = item.ay_id;
                this.activity_inst = item.coordinator_id;
                this.total_hours = item.total_hours;
                this.max_participants = item.max_participants;
                this.max_feedback_rating = item.max_feedback_rating;
                this.certificate_prefix = item.certificate_prefix;
                this.activity_venue = item.venue;
                this.activity_description = item.description;
                this.activity_url = item.activity_url;
                this.attendance_required = item.is_attendance_required;
                this.certificate_enabled = item.is_certificate_enabled;
                this.feedback_enabled = item.is_feedback_enabled;
                this.fee_applicable = item.is_fees_applicable;
                this.approval_required = item.is_approval_required;
                this.activity_id = item.id;
                // Open the dialog
                this.dialog_new = true;
            },
            closeSessionDialog() {
                this.session_id = null;
                this.session_start_date = null;
                this.session_end_date = null;
                this.session_start_time = null;
                this.session_end_time = null;
                this.resource_person = null;
                this.session_description = null;
                this.newSessionDialog = false;
            },
            close_reg_dialog() {
                this.reg_participant_type = null;
                this.registraion_inst = null;
                this.registration_learner = null;
                this.registration_name = null;
                this.registration_mobile_number = null;
                this.registration_org_name = null;
                this.registration_email = null;
                this.registration_fee_amount = null;
                this.payment_mode = null;
                this.affiliation_type = null;
                this.registration_parent = null;
                this.edited_item = 0;
                this.newRegistartionDialog = false;
            },
            close() {
                this.new_activity_name = null;
                this.new_activity_category = null;
                this.from_date = "";
                this.to_date = "";
                this.reg_from_date = "";
                this.reg_to_date = "";
                this.activity_ay = null;
                this.activity_inst = null;
                this.total_hours = 0;
                this.max_participants = 0;
                this.max_feedback_rating = 0;
                this.certificate_prefix = null;
                this.activity_venue = null;
                this.activity_description = null;
                this.activity_url = null;
                // Reset switches
                this.attendance_required = false;
                this.certificate_enabled = false;
                this.feedback_enabled = false;
                this.fee_applicable = false;
                this.approval_required = false;
                this.isactive = true;
                this.dialog_new = false;
            },
            async updateApproval(selectedTasks) {
                const payload = {
                    activity_id: this.slectedActivity.id,
                    approval_list: selectedTasks,
                };
                axios
                    .post("/activity/update_approval", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Approval updated successfully");
                            this.selectedTasks = [];
                            this.approvalDialog = false;
                            this.singleSelect = false;
                            this.slectedActivity.activity_registartion_list = res.data.activity_registartion_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
            async updateAttendance(selectedTasks) {
                const payload = {
                    session_id: this.att_session.id,
                    attendance_list: selectedTasks,
                };
                axios
                    .post("/activity/update_attendance", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Attendance updated successfully");
                            this.selectedTasks = [];
                            this.singleSelect = false;
                            this.att_session.session_attendance_details = res.data.session_attendance_details;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
            async generateBulkCertificate(selectedTasks) {
                // 1. Safety check: Filter out only the approved registrations from selected rows
                const approvedTasks = selectedTasks.filter(task => task.is_approved === true || task.is_approved === 1);

                if (approvedTasks.length === 0) {
                    this.showSnackbar("#b71c1c", "Please select registrations that are Approved.");
                    return;
                }

                // 2. Prepare payload matching your Groovy backend requirements
               const payload = {
                    activity_id: this.slectedActivity.id,
                    selected_ay: this.sel_ay_data, 
                    cert_type_id: this.selected_cert_type, // Now it sends the dynamic ID!
                    registrations: approvedTasks.map(task => ({ registration_id: task.id })) 
                };

                this.output_load = true;

                axios
                    .post("/certificate/genBulkActivityCertificate", payload) 
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", res.data.snackbar || "Certificates Generated Successfully");
                            this.selectedTasks = [];
                            this.approvalDialog = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "Failed to generate certificates");
                        }
                    })
                    .catch((error) => {
                        console.log("error::::" + error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
            },
            importSession(id) {
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("activity_id", id);
                axios
                    .post("/activity/import_new_session", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Session added successfully");
                            this.importSessionDialog = false;
                            this.file = null;
                            this.slectedActivity.activity_session_data_list = res.data.activity_session_data_list;
                        }
                    })
                    .catch((error) => {
                        console.log("error::::" + error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.importSessionDialog = false;
                    })
                    .finally(() => {});
            },
            importAttendance(slectedActivity,att_session){
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("activity_id", slectedActivity);
                formData.append("att_session_id", att_session);
                formData.append("att_session",JSON.stringify(this.att_session.session_attendance_details))
                axios
                    .post("/activity/import_session_attendance", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Attendance added successfully");
                            this.importAttendanceDialog = false;
                            this.file = null;
                            this.att_session.session_attendance_details = res.data.session_attendance_details;
                        }
                    })
                    .catch((error) => {
                        console.log("error::::" + error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.importSessionDialog = false;
                    })
                    .finally(() => {});
            },
            async addNewSession() {
                const payload = {
                    session_id: this.session_id,
                    session_start_date: this.session_start_date,
                    session_end_date: this.session_end_date,
                    session_start_time: this.session_start_time,
                    session_end_time: this.session_end_time,
                    resource_person_id: this.resource_person.id,
                    session_description: this.session_description,
                    activity_id: this.slectedActivity.id,
                };
                axios
                    .post("/activity/add_new_session", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Session added successfully");
                            this.newSessionDialog = false;
                            this.session_id = null;
                            this.session_start_date = null;
                            this.session_end_date = null;
                            this.session_start_time = null;
                            this.session_end_time = null;
                            this.resource_person = null;
                            this.session_description = null;
                            this.slectedActivity.activity_session_data_list = res.data.activity_session_data_list;
                        }
                    })
                    .catch((error) => {
                        console.log("error::::" + error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.newRegistartionDialog = false;
                    })
                    .finally(() => {});
            },
            async addNewRegistration() {
                const payload = {
                    reg_participant_type: this.reg_participant_type.id,

                    ...(this.registraion_inst
                        ? {
                              registraion_inst: this.registraion_inst.id,
                          }
                        : {}),

                    ...(this.registration_learner
                        ? {
                              registration_learner: this.registration_learner.lid,
                          }
                        : {}),

                    registration_name: this.registration_name,
                    registration_mobile_number: this.registration_mobile_number,
                    registration_org_name: this.registration_org_name,
                    registration_email: this.registration_email,
                    registration_fee_amount: this.registration_fee_amount,

                    payment_mode: this.payment_mode.id,
                    affiliation_type: this.affiliation_type,
                    activity_id: this.slectedActivity.id,

                    ...(this.registration_parent
                        ? {
                              registration_parent: this.registration_parent.id,
                          }
                        : {}),

                    registration_id: this.registration_id,
                };
                axios
                    .post("/activity/add_new_registration", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Registration done successfully");

                            this.newRegistartionDialog = false;
                            this.registration_id = null;
                            this.reg_participant_type = null;
                            this.registraion_inst = null;
                            this.registration_learner = null;
                            this.registration_name = null;
                            this.registration_mobile_number = null;
                            this.registration_org_name = null;
                            this.registration_email = null;
                            this.registration_fee_amount = null;
                            this.payment_mode = null;
                            this.affiliation_type = null;
                            this.registration_parent = null;
                            this.slectedActivity.activity_registration_count = res.data.activity_registration_count;
                            this.slectedActivity.activity_registartion_list = res.data.activity_registartion_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.newRegistartionDialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.newRegistartionDialog = false;
                    })
                    .finally(() => {});
            },
            async deleteFeeStructureItem() {
                let payload = {
                    id: this.selecteddeleteFeeStructureItem.id,
                };
                axios
                    .post("/activity/delete_fee_structure", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Fee Structure deleted successfully");
                            this.dialog_delete = false;
                            this.selecteddeleteFeeStructureItem = null;
                            this.slectedActivity.fees_structure_list = res.data.fees_structure_list;
                            this.total_fees_amount = res.data.total_fees_amount;
                            this.registration_fee_amount = this.total_fees_amount;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.dialog_delete = false;
                        this.selecteddeleteFeeStructureItem = null;
                    });
            },
            async addFeeStructure(id) {
                if (
                    this.fee_amount < 0 ||
                    this.acttivity_comp == null ||
                    this.participant_type == null ||
                    this.affiliation_type == null
                ) {
                    this.showSnackbar("#b71c1c", "Please fill all required fields");
                    return;
                }
                let payload = {
                    activity_id: id,
                    activity_comp_id: this.acttivity_comp,
                    participant_type_id: this.participant_type,
                    affiliation_type_id: this.affiliation_type,
                    fee_amount: this.fee_amount,
                };
                axios
                    .post("/activity/add_fee_structure", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#43a047", "Fee Structure added successfully");
                            // Reset form fields
                            this.acttivity_comp = null;
                            this.participant_type = null;
                            this.affiliation_type = null;
                            this.fee_amount = 0;
                             this.slectedActivity.fees_structure_list = res.data.fees_structure_list;
                            this.total_fees_amount = res.data.total_fees_amount;
                            // this.registration_fee_amount = this.total_fees_amount;
                            if (typeof this.calculateFeeAmount === 'function') {
                                this.calculateFeeAmount();
                            }
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
                 calculateFeeAmount() {
                    const feeList = this.slectedActivity.fees_structure_list;

                    if (this.reg_participant_type && this.affiliation_type && feeList) {
                        
                        // 1. Get the string name from the Participant dropdown (e.g., "Student")
                        let selectedParticipantName = this.reg_participant_type.name || this.reg_participant_type.text || this.reg_participant_type;
                        
                        // 2. Get the string name from the Affiliation dropdown
                        // If your dropdown binds to an object, get .name
                        let selectedAffiliationName = this.affiliation_type.name || this.affiliation_type.text || this.affiliation_type;
                        
                        // If your dropdown binds to raw IDs (1 = Internal, 2 = External), map them manually:
                        if (this.affiliation_type == 1) selectedAffiliationName = "Internal";
                        if (this.affiliation_type == 2) selectedAffiliationName = "External";

                        // 3. Find the exact match comparing string to string
                        const matchedFee = feeList.find(fee => {
                            return fee.participant_type == selectedParticipantName && 
                                fee.affiliation_type == selectedAffiliationName;
                        });

                        // 4. Set the exact amount based on the JSON key 'amount'
                        if (matchedFee) {
                            this.registration_fee_amount = matchedFee.amount;
                        } else {
                            this.registration_fee_amount = 0;
                        }
                    } else {
                        this.registration_fee_amount = 0;
                    }
                },
            async onload() {
                if (this.sel_ay_data == null) {
                    this.showSnackbar("#b71c1c", "Please select academic year");
                    return;
                }
                this.output_load = true;
                let payload = {
                    ay_id: this.sel_ay_data,
                    category_id: this.activity_category,
                };
                axios
                    .post("/activity/manageActivity", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.activity_data_list = res.data.activity_data_list;
                            this.output_load = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.output_load = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.output_load = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.output_load = false;
                    })
                    .finally(() => {});
            },
            async addNewActivity() {
                if (
                    this.new_activity_name == null ||
                    this.new_activity_category == null ||
                    this.from_date == "" ||
                    this.to_date == "" ||
                    this.reg_from_date == "" ||
                    this.reg_to_date == "" ||
                    this.activity_ay == null
                ) {
                    this.showSnackbar("#b71c1c", "Please fill all required fields");
                    return;
                }
                let parsedInstId = (this.activity_inst && typeof this.activity_inst === 'object' && this.activity_inst.id) 
                        ? this.activity_inst.id 
                        : this.activity_inst;
                let payload = {
                    name: this.new_activity_name,
                    category_id: this.new_activity_category,
                    ay_id: this.activity_ay,
                    inst_id: parsedInstId,
                    from_date: this.from_date,
                    to_date: this.to_date,
                    reg_from_date: this.reg_from_date,
                    reg_to_date: this.reg_to_date,
                    total_hours: this.total_hours,
                    max_participants: this.max_participants,
                    max_feedback_rating: this.max_feedback_rating,
                    certificate_prefix: this.certificate_prefix,
                    activity_venue: this.activity_venue,
                    activity_description: this.activity_description,
                    attendance_required: this.attendance_required,
                    certificate_enabled: this.certificate_enabled,
                    feedback_enabled: this.feedback_enabled,
                    fee_applicable: this.fee_applicable,
                    approval_required: this.approval_required,
                    appraisal_linked: this.appraisal_linked,
                    is_multiple_sessions_allowed: this.is_multiple_sessions_allowed,
                    activity_url: this.activity_url,
                    activity_id: this.activity_id,
                    isactive: this.isactive,
                };
                axios
                    .post("/activity/add_new_activity", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            // Reset form fields
                            this.activity_id = null;
                            this.new_activity_name = null;
                            this.new_activity_category = null;
                            this.from_date = "";
                            this.to_date = "";
                            this.reg_from_date = "";
                            this.reg_to_date = "";
                            this.activity_ay = null;
                            this.activity_inst = null;
                            this.total_hours = 0;
                            this.max_participants = 0;
                            this.max_feedback_rating = 0;
                            this.certificate_prefix = null;
                            this.activity_venue = null;
                            this.activity_description = null;
                            this.activity_url = null;
                            // Reset switches
                            this.attendance_required = false;
                            this.certificate_enabled = false;
                            this.feedback_enabled = false;
                            this.fee_applicable = false;
                            this.approval_required = false;
                            this.isactive = true;
                            this.resource_person = null;
                            this.showSnackbar("#43a047", "Activity added successfully");
                            this.dialog_new = false;
                            this.onload(); // Refresh the activity list
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
            getInitaialData() {
                axios
                    .post("/activity/getInitaialData")
                    .then((res) => {
                        this.participant_type_data_list = res.data.participant_type_data_list;
                        this.certificate_type_list = res.data.certificate_type_list;
                        this.affiliation_type_data_list = res.data.affiliation_type_data_list;
                        this.payment_mode_list = res.data.payment_mode_list;
                        this.learner_list = res.data.learner_list;
                        this.parent_list = res.data.parent_list;
                        this.resource_person_list = res.data.resource_person_list;
                        this.inst_list = res.data.inst_list;
                        this.activity_category_list = res.data.activity_category_list;
                        this.activity_category_list_with_all = res.data.activity_category_list_with_all;
                        this.ay_std_div_list = res.data.data;
                        this.org_basic_data = res.data.org_basic_data;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
            
            openFeedbackSummary(item) {
                    this.feedbackSummaryActivity = item;

                    this.activity_feedback_list = item.activity_feedback_list || [];

                    this.activity_feedback_registration_list =
                        item.activity_registartion_list || [];

                    this.feedbackSummaryDialog = true;
                },



async openCertificateListDialog(item) {
    this.slectedActivity = item;
    this.certificate_list = [];
    this.aws_path = "";
    this.output_load = true;

    try {
        const payload = {
            activity_id: item.id
        };

        const res = await axios.post(
            "/activity/getActivityCertificateList",
            payload
        );

        console.log("Certificate list API response:", res.data);
        console.log("AWS path received:", res.data.aws_path);

        if (res.data) {
            // Save AWS storage path for viewCertificate()
            this.aws_path = res.data.aws_path || "";

            if (
                res.data.certificate_list &&
                res.data.certificate_list.length > 0
            ) {
                this.certificate_list = res.data.certificate_list;
                this.certificateListDialog = true;
            } else {
                this.showSnackbar(
                    "#b71c1c",
                    "No certificates found."
                );
            }
        } else {
            this.showSnackbar(
                "#b71c1c",
                "No response received from the server."
            );
        }
    } catch (error) {
        console.error("Error fetching certificate list:", error);

        this.showSnackbar(
            "#b71c1c",
            "Something went wrong fetching certificates."
        );
    } finally {
        this.output_load = false;
    }
},

 

viewCertificate(item) {
  if (!item || !item.certificate_file_path) {
    console.error("Certificate file path is missing:", item);
    alert("Certificate PDF path is not available.");
    return;
  }

  const certificatePath = item.certificate_file_path.trim();

  // Case 1: The backend already provides a complete URL.
  if (/^https?:\/\//i.test(certificatePath)) {
    window.open(certificatePath, "_blank", "noopener,noreferrer");
    return;
  }

  // Case 2: Use the AWS base path returned by the backend.
  const awsPath = (this.aws_path || "").trim();

  if (!awsPath) {
    console.error("AWS base path is missing.");
    alert("AWS storage path is not available.");
    return;
  }

  const basePath = awsPath.replace(/\/+$/, "");
  const relativePath = certificatePath.replace(/^\/+/, "");

  const certificateUrl =
    basePath + "/" + relativePath;

  console.log("Certificate URL:", certificateUrl);

  window.open(certificateUrl, "_blank", "noopener,noreferrer");
},


  
        },
        mounted() {
            this.getInitaialData();
        },
    };
</script>
<style scoped>
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid #ff5252;
        cursor: pointer;
    }
    .delete-v-icon {
        color: #ff5252;
        font-size: 15px;
    }
    .delete-avatar:hover {
        background-color: #ff5252;
    }
    .delete-avatar:hover .delete-v-icon {
        color: white;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .yellow-card {
        font-size: 15px;
        background: #bad4e545;
        border-radius: 20px;
        padding: 20px;
        border-left: 5px solid #04456fff;
    }
    .feedback-summary-table-wrapper {
    width: 100%;
    overflow-x: auto;
    margin-top: 10px;
}

.feedback-summary-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    background: #ffffff;
}

.feedback-summary-table th,
.feedback-summary-table td {
    border: 2px solid #1e3a8a !important;
    padding: 10px 8px;
    height: 45px;
    font-size: 14px;
    text-align: center;
    vertical-align: middle;
    color: #000;
    word-break: break-word;
}

.feedback-summary-table th {
    font-weight: bold;
}

.feedback-summary-table th:nth-child(1),
.feedback-summary-table td:nth-child(1) {
    width: 15%;
}

.feedback-summary-table th:nth-child(2),
.feedback-summary-table td:nth-child(2) {
    width: 15%;
}

.feedback-summary-table th:nth-child(3),
.feedback-summary-table td:nth-child(3) {
    width: 14%;
}

.feedback-summary-table th:nth-child(4),
.feedback-summary-table td:nth-child(4) {
    width: 14%;
}

.feedback-summary-table th:nth-child(5),
.feedback-summary-table td:nth-child(5) {
    width: 8%;
}

.feedback-summary-table th:nth-child(6),
.feedback-summary-table td:nth-child(6) {
    width: 20%;
}

.feedback-summary-table th:nth-child(7),
.feedback-summary-table td:nth-child(7) {
    width: 14%;
}

.no-data {
    text-align: center !important;
    color: #777 !important;
    padding: 20px !important;
}
.feedback_data_title{
    color: black;
}
</style>
